module.exports = __webpack_public_path__ + "img/audioIcon.77ce8e70.png";